import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from 'components/Button';

import { Dropdown } from '../../../../components/Dropdown';

export const StyledDropdown = styled(Dropdown)`
  padding: 4px;
  overflow: visible;
`;

export const StyledBulkRevealButton = styled(Button)`
  font-size: 10.5px;
  line-height: 15px;
  padding: 8px 13px;
`;

export const StyledBulkRevealContainer = styled.div`
  position: relative;
`;

export const StyledOptionText = styled.span`
  ${setFontVariant('input2', colorsPalettes.carbon[500])};

  margin-left: 8px;
`;
